import React, {useEffect} from "react";

const CareQualityFooter = ({ currentPath = "", isTopMenu }) => {
  
  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(document.querySelector(".trustpilot-widget"), true);
    }
  }, []);

  return (
    <div className="d-flex flex-row gap-4 gap-md-1 gap-lg-2 gap-xl-4 align-items-center w-100 mb-4 mb-md-0">
      <div className="img-quality-wrapper border-0">
        <img
          src="/images/eligibility/quality-img.png"
          className="img-quality"
        />
      </div>

      <div className="d-flex flex-row gap-2 gap-md-0 gap-lg-1 gap-xl-2 align-items-center">
        <div
          class="trustpilot-widget  d-flex justify-content-end"
          data-locale="en-US"
          data-template-id="5419b732fbfb950b10de65e5"
          data-businessunit-id="57c000ff0000ff000593ef62"
          data-style-height="24px"
          data-style-width="100%"
          data-font-family="Titillium Web">
          <a href="https://www.trustpilot.com/review/thegpservice.co.uk" target="_blank" rel="noopener">Trustpilot</a>
        </div>
      </div>
    </div>
  );
};

export default CareQualityFooter;
